import React from 'react';
import styles from './index.module.css';

// Gifts created through the affiliate's referral link. A gift is "Completed"
// once it has a plan_id (a plan was purchased); otherwise "Incomplete".
const isCompleted = (gift) => gift?.plan_id !== null
  && gift?.plan_id !== undefined
  && `${gift?.plan_id}`.trim() !== '';

const fullName = (gift) => `${gift?.firstname || ''} ${gift?.lastname || ''}`.trim() || '—';

function GiftsTab({ loading, error, gifts }) {
  if (loading) return <p className={styles.stateText}>Loading gifts...</p>;
  if (error) return <p className={styles.stateText}>Couldn&apos;t load gifts. Please try again later.</p>;
  if (!gifts || gifts.length === 0) return <p className={styles.stateText}>No gifts have been created through your link yet.</p>;

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>User</th>
            <th>From</th>
            <th>Promo Code</th>
            <th className={styles.statusCol}>Status</th>
          </tr>
        </thead>
        <tbody>
          {gifts.map((gift, idx) => {
            const completed = isCompleted(gift);
            return (
              <tr key={`${gift?.email || 'gift'}-${idx}`}>
                <td>
                  <div className={styles.fromCell}>
                    <span className={styles.fromName}>{fullName(gift)}</span>
                    {gift?.email && <span className={styles.fromEmail}>{gift.email}</span>}
                  </div>
                </td>
                <td>
                  {(gift?.from_name || gift?.from_email) ? (
                    <div className={styles.fromCell}>
                      {gift?.from_name && <span className={styles.fromName}>{gift.from_name}</span>}
                      {gift?.from_email && <span className={styles.fromEmail}>{gift.from_email}</span>}
                    </div>
                  ) : '—'}
                </td>
                <td>{gift?.promo_code ? gift.promo_code : '—'}</td>
                <td className={styles.statusCol}>
                  <span className={`${styles.badge} ${completed ? styles.badgeCompleted : styles.badgeIncomplete}`}>
                    {completed ? 'Completed' : 'Incomplete'}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default GiftsTab;
